import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { Avatar } from '../Avatar';

interface MergePersonProps {
  isOpen: boolean;
  onClose: () => void;
  onMerge: () => void;
  personName: string;
  selectedPersonName?: string;
  selectedPersonImage?: string;
  newPersonImage?: string;
  isLoading?: boolean;
}

export const MergePerson = ({
  isOpen,
  onClose,
  onMerge,
  personName,
  selectedPersonName,
  selectedPersonImage,
  newPersonImage,
  isLoading = false
}: MergePersonProps) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 ">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-8 relative animate-fadeIn confirmation-box-style">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-400 hover:text-gray-600">
          <SVGAssets.CloseIconGray className="w-5 h-5" />
        </button>

        {/* Header */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            {t('mergePerson')}
          </h2>
        </div>
        <hr className="mb-6 mt-3" />

        {/* Question */}
        <div className="mb-6">
          <p className="text-base text-gray-700">{t('samePerson')}</p>
        </div>

        {/* Avatar Images */}
        <div className="flex items-center justify-center mb-8 -space-x-6">
          {/* First Avatar */}
          <div className="relative z-10">
            {newPersonImage ? (
              <Avatar
                alt={personName}
                src={newPersonImage}
                className="w-24 h-24 rounded-full object-cover border-1 border-white shadow-md"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center border-2 border-white shadow-md">
                <SVGAssets.Avatar className="w-14 h-14 text-gray-400" />
              </div>
            )}
          </div>

          {/* Second Avatar */}
          <div className="relative z-0">
            {selectedPersonImage ? (
              <Avatar
                alt={selectedPersonName || ''}
                src={selectedPersonImage}
                className="w-24 h-24 rounded-full object-cover border-1 border-white shadow-md"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-gray-200 flex items-center justify-center border-2 border-white shadow-md">
                <SVGAssets.Avatar className="w-14 h-14 text-gray-400" />
              </div>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="grid grid-cols-2 gap-3">
          <Button
            btnStyle="link"
            type="button"
            isDisabled={isLoading}
            onClick={onClose}
            className="px-2 py-2 !bg-[#F9FEE9] text-[var(--na-primary-color)] font-medium rounded-md text-sm border border-[#DCDCDC]">
            {t('no')}
          </Button>
          <Button
            btnStyle="primary"
            type="submit"
            loading={isLoading}
            isDisabled={isLoading}
            onClick={onMerge}
            className={`px-6 rounded-lg py-3 text-sm `}>
            {t('yes')}
          </Button>
        </div>
      </div>
    </div>
  );
};
